const STORAGE_KEY = 'snowbotix_invitation_signup';

export function parseInvitationSearchParams(search = '') {
  const raw = search.startsWith('?') ? search.slice(1) : search;
  const params = new URLSearchParams(raw);
  return {
    invitationToken: params.get('invitationToken') || params.get('token') || '',
    email: (params.get('email') || '').trim(),
    role: (params.get('role') || '').trim(),
  };
}

export function readStoredInvitationParams() {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    if (!parsed?.invitationToken) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function persistInvitationParams(params) {
  if (!params?.invitationToken) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(params));
  } catch {
    // Ignore storage failures (private browsing, etc.)
  }
}

export function clearStoredInvitationParams() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Ignore
  }
}

export function resolveInvitationParams(searchParams) {
  const fromRouter = parseInvitationSearchParams(
    typeof searchParams === 'string' ? searchParams : `?${searchParams.toString()}`
  );

  if (typeof window !== 'undefined') {
    const fromLocation = parseInvitationSearchParams(window.location.search);
    if (!fromRouter.invitationToken && fromLocation.invitationToken) {
      Object.assign(fromRouter, fromLocation);
    }
    if (!fromRouter.email && fromLocation.email) fromRouter.email = fromLocation.email;
    if (!fromRouter.role && fromLocation.role) fromRouter.role = fromLocation.role;
  }

  if (fromRouter.invitationToken) {
    persistInvitationParams(fromRouter);
    return fromRouter;
  }

  if (
    typeof window !== 'undefined'
    && window.location.pathname === '/signup'
    && !window.location.search
  ) {
    const stored = readStoredInvitationParams();
    if (stored) return stored;
  }

  return fromRouter;
}
